import { stringify, parse } from "query-string";
import { debounce } from "lodash";

const searches = {};

export function registerSearch(search) {
  searches[search.listId] = search;
}

export function unregisterSearch(search) {
  delete searches[search.listId];
}

const updateHistory = filters => {
  const existingFilters = parse(window.location.search);
  const updatedFilters = {
    ...existingFilters,
    ...filters
  };
  const paramsStr =
    Object.keys(updatedFilters).length > 0
      ? `?${stringify(updatedFilters)}`
      : "";

  window.history.pushState(null, null, paramsStr);
};

const debounceUpdateHistory = debounce((field, value) => {
  updateHistory({ page: 1, [field]: value });
}, 300);

// Redux middleware that keeps URL params and browser history in sync with various paginate-this actions.
const syncSearchStateWithUrl = store => next => action => {
  const state = store.getState();

  Object.keys(searches).forEach(listId => {
    const search = searches[listId];

    switch (action.type) {
      case `@@paginate-this/GO_TO_PAGE_${search.listId}`:
        updateHistory({ page: action.page });
        break;
      case `@@paginate-this/NEXT_PAGE_${search.listId}`:
        updateHistory({ page: search.stateLocator(state).get("page") + 1 });
        break;
      case `@@paginate-this/PREVIOUS_PAGE_${search.listId}`:
        updateHistory({ page: search.stateLocator(state).get("page") - 1 });
        break;
      case `@@paginate-this/SET_FILTER_${search.listId}`:
        debounceUpdateHistory(action.field, action.value);
        break;
      case `@@paginate-this/SET_FILTERS_${search.listId}`:
        updateHistory({ page: 1, ...action.filters });
        break;
      default:
    }
  });

  return next(action);
};

export default syncSearchStateWithUrl;



// WEBPACK FOOTER //
// ./app/middleware/syncSearchStateWithUrl.js